/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  attachMedia(cannedResponseId, blobId) {
    return axios.post(`${this.url}/${cannedResponseId}/attachments`, {
      blob_id: blobId,
    });
  }

  deleteAttachment(cannedResponseId, attachmentId) {
    return axios.delete(
      `${this.url}/${cannedResponseId}/attachments/${attachmentId}`
    );
  }
}

export default new CannedResponse();
